export default "/images/vendor/flag-icons/flags/4x3/un.svg?59626118150774702f9f7b49c267b7b7";